import { REGEX_CODIGO_GENERACION, REGEX_DUI2, REGEX_FECHA_EMISION, REGEX_FECHA_EMISION_DDMMYYYY, REGEX_NIT2, REGEX_NRC } from "../constants/Regex"

export const PLANTILLAS = {
  RETENCIONES_JSON: `${process.env.REACT_APP_PLANTILLA_RETENCIONES_JSON}`,
  RETENCIONES_XLSX: `${process.env.REACT_APP_PLANTILLA_RETENCIONES_XLSX}`,
  ANEXO_7_JSON: `${process.env.REACT_APP_PLANTILLA_ANEXO_7_RETENCION_JSON}`,
  ANEXO_7_XLSX: `${process.env.REACT_APP_PLANTILLA_ANEXO_7_RETENCION_XLSX}`,
  ANEXO_6_JSON: `${process.env.REACT_APP_PLANTILLA_ANEXO_6_ANTICIPO_JSON}`,
  ANEXO_6_XLSX: `${process.env.REACT_APP_PLANTILLA_ANEXO_6_ANTICIPO_XLSX}`,
  COMPRAS_JSON: `${process.env.REACT_APP_PLANTILLA_COMPRAS_JSON}`,
  COMPRAS_VARIANTE_JSON: `${process.env.REACT_APP_PLANTILLA_COMPRAS_VARIANTE_JSON}`,
  COMPRAS_XLSX: `${process.env.REACT_APP_PLANTILLA_COMPRAS_XLSX}`,
};

const stringToDate = (dateString: string): Date => {
  let day = 0, month = 0, year = 0;

  if (dateString.includes('/')) {
    // Formato dd/mm/yyyy
    [day, month, year] = dateString.split('/').map(part => parseInt(part, 10));
  } else if (dateString.includes('-')) {
    // Formato yyyy-mm-dd
    [year, month, day] = dateString.split('-').map(part => parseInt(part, 10));
  }

  return new Date(year, month - 1, day);
}

const validRangeFechasLibro = (formAux: any, date: string):boolean => {
  const valid:boolean = true;

  if (formAux.startDate && formAux.endDate) {
    let inicio = new Date(formAux.startDate);
    inicio.setUTCHours(0, 0, 0, 0);

    let final = new Date(formAux.endDate);
    final.setUTCHours(0, 0, 0, 0);

    let fecha = stringToDate(date);
    fecha.setUTCHours(0, 0, 0, 0);

    return fecha >= inicio && fecha <= final;
  }

  return valid;
}

// -------------------------------------------------------------------------
// COMPRAS
//-------------------------------------------------------------------------

export const validRowCompras = (row: any, extFile: string): [boolean, any] => {
  if (extFile === ".xlsx") {
    return [isValidRowComprasXLSX(row), false];
  } else {
    return isValidRowComprasJSON(row);
  }
}

export const isValidRowComprasXLSX = (row: any):boolean => {
  return (
    parseInt(row["NUM CORRELATIVO"]) > 0 &&
    row["FECHA EMISION"] &&
    row["TIPO DE DOCUMENTO"] &&
    row["NUMERO DE COMPROBANTE"] &&
    row["NUMERO DE CONTROL"] &&
    row["CODIGO GENERACION"] &&
    row["SELLO RECEPCION"] &&
    row["NOMBRE PROVEEDOR"] &&
    (REGEX_NIT2.test(`${row["NIT PROVEEDOR"]}`) || REGEX_DUI2.test(`${row["DUI PROVEEDOR"]}`)) &&
    parseInt(row["TIPO DE OPERACION"]) >= 0 &&
    parseInt(row["CLASIFICACION"]) >= 0 &&
    parseInt(row["TIPO CLASIFICACION"]) >= 0 &&
    parseInt(row["SECTOR"]) > 0 &&
    parseFloat(row["EXENTAS LOCALES"]) >= 0 &&
    parseFloat(row["EXENTAS IMPORTACIONES"]) >= 0 &&
    parseFloat(row["EXENTAS INTERNACIONALES"]) >= 0 &&
    parseFloat(row["GRAVADAS LOCALES"]) >= 0 &&
    parseFloat(row["GRAVADAS IMPORTACIONES"]) >= 0 &&
    parseFloat(row["GRAVADAS IMPORTACIONES SERVICIOS"]) >= 0 &&
    parseFloat(row["GRAVADAS INTERNACIONALES"]) >= 0 &&
    parseFloat(row["CREDITO FISCAL IVA"]) >= 0 &&
    parseFloat(row["TOTAL COMPRAS"]) >= 0 &&
    parseFloat(row["PERCEPCION"]) >= 0 &&
    parseFloat(row["RETENCION"]) >= 0
  );
}

export const isValidRowComprasJSON = (row: any):[boolean, any]  => {
  // Recorrer propiedades del JSON
  const hasRequiredFields = (obj: any): any|null => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (typeof value === 'object' && value !== null) {
          // Objeto como propiedad recorrer
          return hasRequiredFields(value) || null;
        } else if (REGEX_CODIGO_GENERACION.test(value)) {
          // Buscar codigogeneracion y fechaEmi
          const fechaKey = Object.keys(obj).find(
            k => REGEX_FECHA_EMISION.test(obj[k]) || REGEX_FECHA_EMISION_DDMMYYYY.test(obj[k])
          );

          if (fechaKey) {
            let fechaEmi = obj[fechaKey];

            // Convertir si es formato DD/MM/YYYY
            if (REGEX_FECHA_EMISION_DDMMYYYY.test(fechaEmi)) {
              // Extraer solo la fecha si viene con mas texto
              const fechaSolo = fechaEmi.match(REGEX_FECHA_EMISION_DDMMYYYY)[0];
              const [dia, mes, anio] = fechaSolo.split("/");
              fechaEmi = `${anio}-${mes}-${dia}`;
            } else {
              fechaEmi = fechaEmi.match(REGEX_FECHA_EMISION)[0];
            }

            // Retornar resultado
            return {codigoGeneracion: value, fechaEmi: fechaEmi};
          }
        }
      }
    }
    return null;
  };

  const result = hasRequiredFields(row);
  return [!!result, result];
}

export const isValidRowComprasJSONVariante = (row: any):boolean => {
  try {
    return (
      row.identificacion.numeroControl &&
      row.identificacion.codigoGeneracion &&
      row.identificacion.tipoDte &&
      row.identificacion.fecEmi &&
      row.emisor.nit &&
      row.emisor.nrc &&
      row.emisor.nombre &&
      row.resumen.montoTotalOperacion >= 0 &&
      row.resumen.totalExenta >= 0 &&
      row.resumen.totalGravada >= 0 &&
      row.resumen.ivaRete1 >= 0 &&
      row.resumen.ivaPerci1 >= 0 &&
      row.resumen.tributos &&
      (row.selloRecibido || row.ResponseMH?.selloRecibido || row.respuestaHacienda?.selloRecibido || row.responseMH?.selloRecibido)
    );
  } catch {
    return false;
  }
}

export const mapeoRowJSONCompras = (cleanedData: any) => {
  return cleanedData
    .map((row: any, index: number) => {
      // Validar datos no nulos
      const { documento, selloVal } = row;
      if (!documento) return null;

      const { identificacion, emisor, resumen } = documento;
      if (!identificacion || !emisor || !resumen) return null;

      const [year, month, day] = identificacion.fecEmi.split('-');
      const fechaFormateada = `${day}/${month}/${year}`;

      return {
        numCorrelativo: index + 1,
        fechaEmision: fechaFormateada,
        tipoDocumento: identificacion.tipoDte,
        numeroComprobante: parseInt(
          identificacion.numeroControl.substring(
            identificacion.numeroControl.lastIndexOf('-') + 1
          ),
          10
        ),
        numeroControl: identificacion.numeroControl,
        codigoGeneracion: identificacion.codigoGeneracion,
        selloRecepcion: selloVal,
        nombreProveedor: emisor.nombre,
        nitProveedor: emisor.nit,
        nrcProveedor: emisor.nrc,
        duiProveedor: '',
        tipoOperacion: 0,
        clasificacion: 0,
        tipoClasificacion: 0,
        sector: 0,
        exentasLocales: resumen.totalExenta,
        exentasImportaciones: 0.0,
        exentasInternacionales: 0.0,
        gravadasLocales: resumen.totalGravada,
        gravadasImportaciones: 0.0,
        gravadasImportacionesServicios: 0.0,
        gravadasInternacionales: 0.0,
        creditoFiscalIva:
          resumen.tributos?.find((tributo: any) => tributo.codigo === '20')
            ?.valor ?? 0.0,
        totalCompras: resumen.montoTotalOperacion,
        percepcion: resumen.ivaPerci1,
        retencion: resumen.ivaRete1,
      };
    })
    .filter((row: any) => row !== null); // Filtra los valores nulos
};

// -------------------------------------------------------------------------
// RETENCIONES 
//-------------------------------------------------------------------------

export const validRowRetenciones = (row: any, extFile: string, formAux: any): boolean => {
  if (extFile === ".xlsx") {
    return isValidRowRetencionXLSX(row, formAux);
  } else {
    return isValidRowRetencionJSON(row, formAux);
  }
}

export const isValidRowRetencionXLSX = (row: any, formAux: any):boolean => {
  return (
    row["NUMERO DOCUMENTO"] &&
    row.FECHA &&
    row.SERIE &&
    row.PROVEEDOR &&
    row.FECHA &&
    //validRangeFechasLibro(formAux, row.FECHA) &&
    parseInt(row.CCF) > 0 &&
    parseFloat(row.GRAVADAS) > 0 &&
    REGEX_NRC.test(`${row.REGISTRO}`) &&
    REGEX_NIT2.test(`${row.NIT}`) &&
    (row.DUI ? REGEX_DUI2.test(row.DUI) : true)
  );
}

export const isValidRowRetencionJSON = (row: any, formAux: any):boolean => {
  try {
    return (
      row.identificacion.tipoDte &&
      row.identificacion.fecEmi &&
      //validRangeFechasLibro(formAux, row.identificacion.fecEmi) &&
      row.identificacion.numeroControl &&
      row.identificacion.codigoGeneracion &&
      REGEX_NIT2.test(`${row.emisor.nit}`) &&
      row.emisor.nrc &&
      row.emisor.nombre &&
      row.emisor.nombreComercial &&
      row.cuerpoDocumento[0].tipoDte === "03" &&
      row.cuerpoDocumento[0].numDocumento &&
      parseFloat(row.cuerpoDocumento[0].montoSujetoGrav) > 0 &&
      parseFloat(row.cuerpoDocumento[0].ivaRetenido) > 0 &&
      row.selloRecibido
    );
  } catch (e) {
    return false;
  }
}

export const mapeoRowRetencionXLSX = (cleanedData: any) => {
  return cleanedData.map((row: any) => ({
    numCorrelativo: parseInt(row["NUM CORRELATIVO"]),
    fechaEmision: row["FECHA EMISION"],
    tipoDocumento: row["TIPO DE DOCUMENTO"], 
    numeroComprobante: row["NUMERO DE COMPROBANTE"],
    numeroControl: row["NUMERO DE CONTROL"],
    codigoGeneracion: row["CODIGO GENERACION"],
    selloRecepcion: row["SELLO RECEPCION"],
    nombreProveedor: row["NOMBRE PROVEEDOR"],
    nitProveedor: row["NIT PROVEEDOR"] ?? '',
    duiProveedor: row["DUI PROVEEDOR"] ?? '',
    nrcProveedor: row["NRC PROVEEDOR"],
    tipoOperacion: parseInt(row["TIPO DE OPERACION"]),
    clasificacion: parseInt(row["CLASIFICACION"]),
    tipoClasificacion: parseInt(row["TIPO CLASIFICACION"]),
    sector: parseInt(row["SECTOR"]),
    exentasLocales: parseFloat(row["EXENTAS LOCALES"]),
    exentasImportaciones: parseFloat(row["EXENTAS IMPORTACIONES"]),
    exentasInternacionales: parseFloat(row["EXENTAS INTERNACIONALES"]),
    gravadasLocales: parseFloat(row["GRAVADAS LOCALES"]),
    gravadasImportaciones: parseFloat(row["GRAVADAS IMPORTACIONES"]),
    gravadasImportacionesServicios: parseFloat(row["GRAVADAS IMPORTACIONES SERVICIOS"]),
    gravadasInternacionales: parseFloat(row["GRAVADAS INTERNACIONALES"]),
    creditoFiscalIva: parseFloat(row["CREDITO FISCAL IVA"]),
    totalCompras: parseFloat(row["TOTAL COMPRAS"]),
    percepcion: parseFloat(row["PERCEPCION"]),
    retencion: parseFloat(row["RETENCION"])
  }));
}

// -------------------------------------------------------------------------
// ANEXO 6 ANTICIPO 
//-------------------------------------------------------------------------

export const validRowAnexo6Anticipo = (row: any, extFile: string): boolean => {
  if (extFile === ".xlsx") {
    return isValidRowAnexo6AnticipoXLSX(row);
  } else {
    return isValidRowAnexo6AnticipoJSON(row);
  }
}

export const isValidRowAnexo6AnticipoXLSX = (row: any):boolean => {
  return (
    (REGEX_NIT2.test(row["NIT AGENTE"]) || REGEX_DUI2.test(row["DUI AGENTE"])) &&
    row["FECHA EMISION"] &&
    row.SERIE &&
    row["NUMERO DOCUMENTO"] &&
    parseFloat(row["MONTO SUJETO"]) > 0
  );
}

export const isValidRowAnexo6AnticipoJSON = (row: any):boolean => {
  try {
    return (
      row.identificacion.tipoDte &&
      row.identificacion.fecEmi &&
      row.identificacion.numeroControl &&
      row.identificacion.codigoGeneracion &&
      row.selloRecibido &&
      REGEX_NIT2.test(`${row.emisor.nit}`) &&
      row.emisor.nrc &&
      row.emisor.nombre &&
      parseFloat(row.cuerpoDocumento.montoSujetoPercepcion) >= 0 &&
      parseFloat(row.cuerpoDocumento.ivaPercibido) >= 0
    );
  } catch {
    return false;
  }
}

// -------------------------------------------------------------------------
// ANEXO 7 RETENCION 
//-------------------------------------------------------------------------

export const validRowAnexo7Retencion = (row: any, extFile: string, formAux: any): boolean => {
  if (extFile === ".xlsx") {
    return isValidRowAnexo7RetencionXLSX(row, formAux);
  } else {
    return isValidRowAnexo7RetencionJSON(row, formAux);
  }
}

export const isValidRowAnexo7RetencionXLSX = (row: any, formAux: any):boolean => {
  return (
    (REGEX_NIT2.test(row["NIT AGENTE"]) || REGEX_DUI2.test(row["DUI AGENTE"])) &&
    row["FECHA EMISION"] &&
    validRangeFechasLibro(formAux, row["FECHA EMISION"]) &&
    (row["TIPO DOCUMENTO"] === "05" || row["TIPO DOCUMENTO"] === "06" || row["TIPO DOCUMENTO"] === "07") &&
    row.SERIE &&
    row["NUMERO DOCUMENTO"] &&
    parseFloat(row["MONTO SUJETO"]) > 0
  );
}

export const isValidRowAnexo7RetencionJSON = (row: any, formAux: any):boolean => {
  return (
    (REGEX_NIT2.test(row.nitAgente) || REGEX_DUI2.test(row.duiAgente)) &&
    row.fechaEmision &&
    validRangeFechasLibro(formAux, row.fechaEmision) &&
    (row.tipoDocumento === "05" || row.tipoDocumento === "06" || row.tipoDocumento === "07") &&
    row.serie &&
    row.numeroDocumento &&
    parseFloat(row.montoSujeto) > 0
  );
}
